const ERROR_MESSAGE_MILEAGE = "Please enter a value between 1,000 and 100,000";
const ERROR_MESSAGE_ELECTRIC = "Please enter a value between 0 and 1.0000";
const ERROR_MESSAGE_FUEL = "Please enter a value between 1.0000 and 2.0000";

let Validation = {
    validateMileage: function (value, errorCallback, passedCallback) {
        let fieldName = "mileage";
        if (isNaN(value) || (value > 100000 || value < 1000)) {
            errorCallback({name: fieldName, message: ERROR_MESSAGE_MILEAGE});
            return;
        }
        passedCallback(fieldName);
    },
    validateElectric: function (value, errorCallback, passedCallback) {
        let fieldName = "electric";
        if (isNaN(value) || (value > 1 || value < 0)) {
            errorCallback({name: fieldName, message: ERROR_MESSAGE_ELECTRIC});
            return;
        }
        passedCallback(fieldName);
    },
    validatePetrol: function (value, errorCallback, passedCallback) {
        let fieldName = "petrol";
        if (isNaN(value) || (value > 2 || value < 1)) {
            errorCallback({name: fieldName, message: ERROR_MESSAGE_FUEL});
            return;
        }
        passedCallback(fieldName);
    },
    validateDiesel: function (value, errorCallback, passedCallback) {
        let fieldName = "diesel";
        if (isNaN(value) || (value > 2 || value < 1)) {
            errorCallback({name: fieldName, message: ERROR_MESSAGE_FUEL});
            return;
        }
        passedCallback(fieldName);
    },
};

export default Validation;